
<template>
    <div id="header">
        <a href="/classic/index?redirect=false" class="btn-link-home" data-trace="공홈바로가기1">lineage2 홈 바로가기</a>
        <a href="/promotion/update_history/index#!/classic/" class="btn-link-update">업데이트 연대기</a>
        <div class="util">
            <a href="/classic/index?redirect=false" class="btn-link-main" data-trace="공홈바로가기2">공홈 바로가기</a>
            <a href="/" data-cookie="INDEX_WEB_VISIT_190220_jinkamael, false" data-redirect="/classic/index?redirect=false" class="btn-link-day" data-trace="오늘하루안보기">오늘하루 그만보기</a>
            <a href="/classic/events/2019/190220_jinkamael/strongjob" class="btn-link-event" data-trace="이벤트">EVENT</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        mounted(){
        }
    };
</script>

<style lang="scss">
    #header {
        @include hide-text();
        text-indent: 0;
        font-size:0;
        @include position-abs($width: 100%, $height: 100px);
        background:rgba(0, 0, 0, 0.5);
        z-index: 10;

        .btn-link-home {
            @include position-abs($width: 141px, $height: 26px, $left: 100px, $top: 54px);
            @include bg($bg: 'img/logo.png');
        }
        .btn-link-update {
            @include position-abs($width: 106px, $height: 16px, $left: 257px, $top: 60px);
            @include bg($bg: 'img/logo_history.png');
        }
        .util {
            @include position-abs($height: 35px, $right: 75px, $top: 49px);
            font-size: 0;
            > a {
                position: relative;
                display: block;
                float:left;
                left: auto;
                margin-left: 6px;
                opacity: .8;
                transition: all .3s;
                &:hover {
                    opacity: 1;
                }
            }
            .btn-link-main {
                @include bg($bg: 'img/btn-home.png');
                width: 146px;
                height: 35px;
            }
            .btn-link-day {
                @include bg($bg: 'img/btn-today.png');
                width: 146px;
                height: 35px;
            }
            .btn-link-event {
                @include bg($bg: 'img/btn-event.png');
                width: 100px;
                height: 35px;
            }
        }
    }
</style>
